import beanUtils from './beanUtils'
import dateUtils from './dateUtils'
import mathTools from './mathTools'
import pageTool from './pageTool'
import objTreat from './objTreat'
import privacy from './privacy'
import Cookies from 'js-cookie'
import {Notification} from "element-ui";
import token from "@/utils/token";

const server = require('../../../server.config')

/**
 * @Description: 数据交互工具 2.0
 * @author wcd
 * @date 2020/3/4
*/
let data={};
export default{

  tool () {
    return {
      fileUrl:server.apiConfig.host+':'+server.apiConfig.port+'/purchase/t-file/downloadFile?fileId=',
      server:server,
      privacy:privacy,
      bean: beanUtils,
      dateUtils: dateUtils,
      mathTools: mathTools,
      pageTool: pageTool,
      token: token,
      objTreat: objTreat,
    }
  },
  /**
   *  获取值
   */
  getData(key) {
    try {
      return data[key];
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },
  getAll(){
    return data;
  },
  /**
   *  设置值
   */
  setData(key,value) {
    try {
      data[key]=value;
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },
  /**
   *  清除某个值
   */
  delData(key) {
    try {
      delete data[key]
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },
  /**
   *  清除所有值
   */
  delAll(){
    data={};
  },

  /**
   * @Description: 转存到缓存
   * @author wcd
   * @date 2020/3/5
  */
  setCookies(key,value){
    try {
      if (value===undefined||value===null||value===""){
        Cookies.set(key,value)
        return
      }
      Cookies.set(key,privacy.lock(value.toString()))
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },


  /**
   * @Description: 获取缓存
   * @author wcd
   * @date 2020/3/5
   */
  getCookies(key){
    try {
      let newVar = Cookies.get(key);
      if (newVar===undefined||newVar===null||newVar===""){
        return newVar
      }
      return privacy.unlock(Cookies.get(key))
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },

  /**
   * @Description: 转存到缓存(存对象)
   * @author wcd
   * @date 2020/3/5
   */
  setObjCookies(key,value){
    try {
      if (value===undefined||value===null||value===""){
        Cookies.set(key,value)
        return
      }
      Cookies.set(key,privacy.lock(JSON.stringify(value)))
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },
  /**
   * @Description: 获取缓存（取对象）
   * @author wcd
   * @date 2020/3/5
   */
  getObjCookies(key){
    try {
      let newVar = Cookies.get(key);
      if (newVar===undefined||newVar===null||newVar===""){
        return newVar
      }
      return JSON.parse(privacy.unlock(Cookies.get(key)))
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },



  /**
   * @Description: 获取所有缓存
   * @author wcd
   * @date 2020/3/5
   */
  getAllCookies(){
    try {
     return document.cookie
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },


  /**
   * @Description: 删除缓存
   * @author wcd
   * @date 2020/3/5
   */
  delCookies(key){
    try {
      Cookies.remove(key)
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },




  /**
   * @Description: 删除所有缓存
   * @author wcd
   * @date 2020/3/5
   */
  delAllCookies(){
    try {
      let keys=document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (let i = keys.length; i--;)
          document.cookie=keys[i]+'=0;expires=' + new Date( 0).toUTCString()
      }
    }catch (e) {
      console.error('操作失败，原因：',e)
    }
  },


  /**
   * @Description: 消息提示
   * @author wcd
   * @date 2020/3/10
   */
  msg(message, type) {
    if (type===0){
      Notification.error({
        title: message
      })
    }else {
      Notification.success({
        title: message
      })
    }

  },



}



// WEBPACK FOOTER //
// ./src/utils/cdUtils/room.js